    /**
     * Initialize Single Project Scroll Sync Effect
     * @param {number} scrollSpeed - Percentage of scroll distance (0.5 = 50%, 0.8 = 80%, etc.)
     */
    function initSingleProjectScrollSync(scrollSpeed = 1) {
        // Disable on mobile/tablet
        if (window.innerWidth <= 768) return;

        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

        const projectContainer = document.querySelector('.project-content__container');
        if (!projectContainer) return;

        // Check if this container already has scroll sync initialized
        if (projectContainer.dataset.scrollSyncInitialized) return;

        const projectContent = projectContainer.querySelector('.single-project__content');
        const showcaseContainer = projectContainer.querySelector('.column__project-showcase');

        if (!projectContent || !showcaseContainer) return;

        // Calculate the parallax scroll distances
        const showcaseHeight = showcaseContainer.offsetHeight;
        const viewportHeight = window.innerHeight;
        const contentHeight = projectContent.offsetHeight;

         // Calculate how much the content needs to move relative to the showcase
         const maxPadding = Math.max(0, showcaseHeight - viewportHeight) * scrollSpeed;
         const contentScrollDistance = Math.max(0, contentHeight - viewportHeight) * scrollSpeed;

         // Check if we're in a modal context
         const isInModal = projectContainer.closest('#dynamic-content-modal');
         const scroller = isInModal ? projectContainer.closest('.modal__content') : window;

         // Create the scroll-triggered parallax animation
         const scrollTrigger = ScrollTrigger.create({
             trigger: projectContainer,
             start: 'top top',
             end: `bottom bottom`,
             scrub: 1,
             scroller: scroller,
             onUpdate: (self) => {
                 const progress = self.progress;

                 // Add padding to push content down
                 const currentPadding = progress * maxPadding;

                 // Also translate the content up to create parallax effect
                 const translateY = progress * contentScrollDistance;

                 console.log('Applying styles:', {
                     paddingTop: currentPadding,
                     marginBottom: -currentPadding,
                     y: -translateY
                 });

                 gsap.set(projectContent, {
                     paddingTop: currentPadding,
                     marginBottom: -currentPadding,
                     y: -translateY,
                     ease: 'none'
                 });
             },
             onToggle: (self) => {
                 console.log('ScrollTrigger toggled:', self.isActive);
             }
         });

        // Mark this container as initialized
        projectContainer.dataset.scrollSyncInitialized = 'true';
    }
